import {ACTION_TYPE} from "utils/constants";

export const handleAssetLibrary = option => ({
  type: ACTION_TYPE.HANDLE_ASSET_LIBRARY,
  payload: option,
});

export const handleAssetLibraryOpen = option => ({
  type: ACTION_TYPE.HANDLE_ASSET_LIBRARY_OPEN,
});

export const setCurrentSearchParams = params => ({
  type: ACTION_TYPE.SET_CURRENT_SEARCH_PARAMS,
  payload: params,
});
